import clsx from 'clsx';
import type {HTMLAttributes} from 'react';
import styles from './Controls.module.scss';

export interface ButtonProps
  extends Omit<HTMLAttributes<HTMLButtonElement>, 'loading'> {
  main?: boolean;
  loading?: boolean;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
}

export function Button({main, loading, className, type, disabled, ...props}: ButtonProps) {
  return (
    <button
      className={clsx(
        styles.button,
        className,
        main && styles.main,
        loading && 'loading',
      )}
      onMouseUp={event => (event.target as HTMLButtonElement).blur()}
      type={type ?? 'button'}
      disabled={disabled}
      {...props}
    />
  );
}
